// import { Link } from "react-router-dom";
import Munene from "../assets/services/Munene.jpg";
import Antony from "../assets/services/Antony.jpg";
import events from "../assets/services/events.jpg";
import girls from "../assets/services/girls.jpg";

export const stories = [
  {
    id: 1,
    title: "From Financial Struggles to University Success",
    name: "Ronny Munene",
    role: "University Student",
    description:
      "I received bursary support that enabled me to complete secondary school and join university.",
    image: Munene,
    link: "/stories/munene",
  },
  {
    id: 2,
    title: "Supporting Orphans Through Education",
    name: "Antony Mwandiki",
    role: "Secondary Student",
    description:
      "I stayed in school and completed KCSE successfully through the constituency bursary.",
    image: Antony,
    link: "/stories/antony",
  },
  {
    id: 3,
    title: "Annual Bursary Distribution Event",
    name: "Event Attendees",
    role: "TVET Students",
    description:
      "Hundreds of learners received financial assistance during the award ceremony.",
    image: events,
    link: "/stories/event",
  },
  {
    id: 4,
    title: "Empowering Girls Through Education",
    name: "Vulnerable Girls",
    role: "Secondary Students",
    description:
      "The bursary program supports vulnerable girls to stay in school and pursue their dreams.",
    image: girls,
    link: "/stories/girls",
  },
];
